
import { prop, Vue } from "vue-class-component";

class Props {
  value = prop<string>({
    required: false,
    default: "",
    type: String,
  });
  titleClass = prop<string>({
    required: false,
    default: "font-semibold",
    type: String,
  });
  valueClass = prop<string>({
    required: false,
    default: "",
    type: String,
  });
}

export default class ManagingCountryReadRow extends Vue.with(Props) {
  get managingCountry() {
    return this.value;
  }
}
